"use client";

import React, { useState } from "react";
import { FilterData } from "../../../sanity/lib/queries/getSolutionFilterData";
import { SolutionPreview } from "./solutionPreview";
import { SolutionFilter } from "./solutionFilter";
import { Solution } from "../../../sanity/lib/types/solutions";

export const SolutionGrid = (data: {
    solutions: Solution[];
    filterData: FilterData;
    label: string;
    serviceLabel: string;
    industryLabel: string;
    emptyStateMessage: string;
    emptyShowcaseSolutions: Array<Solution>;
}) => {
    const [filteredSolutions, setFilteredSolutions] = useState<Solution[]>(data.solutions);
    const [filterValues, setFilterValues] = useState<Array<string>>([]);
    const [isListLayout, setIsListLayout] = useState(true);

    const filterSolutions = async (id: string) => {
        let newFilter;
        if (filterValues.indexOf(id) !== -1) {
            newFilter = filterValues.filter((value) => value !== id);
        } else {
            newFilter = [...filterValues, id];
        }
        setFilterValues(newFilter);

        if (newFilter.length === 0) {
            setFilteredSolutions(data.solutions);
            return;
        }

        const solutionsToFilter = data.solutions.filter((solution) => {
            const industryMatch =
                solution.industry?._id && newFilter.includes(solution.industry._id);
            const serviceMatch = solution.services?.some((service) =>
                newFilter.includes(service?.service?._id || "y"),
            );
            return industryMatch || serviceMatch;
        });

        setFilteredSolutions(solutionsToFilter);
    };

    return (
        data.solutions &&
        data.filterData && (
            <section className="container border-t">
                <h2 className="absolute -top-[100vh]">Solutions Overview</h2>
                <div className="mx-2.5 md:mx-5 pb-5">
                    <SolutionFilter
                        setIsListLayout={setIsListLayout}
                        isListLayout={isListLayout}
                        onFilterSolutions={filterSolutions}
                        filterValues={filterValues}
                        filterData={data.filterData}
                        label={data.label}
                        industryLabel={data.industryLabel}
                        serviceLabel={data.serviceLabel}
                    />
                    <div
                        className={`grid grid-cols-6 ${
                            isListLayout ? "gap-2" : "gap-2.5"
                        } md:gap-5 solutions-grid`}
                    >
                        {filteredSolutions?.map((solution, index) => (
                            <SolutionPreview
                                solution={solution}
                                isListLayout={isListLayout}
                                key={index}
                            />
                        ))}
                        {filteredSolutions.length === 0 && (
                            <div className="col-span-6 mt-20">
                                <p className="m-headline-3 md:d-headline-1">
                                    {data.emptyStateMessage}
                                </p>

                                <div className="grid grid-cols-6 gap-2.5 md:gap-5 mt-10 md:mt-20">
                                    {data.emptyShowcaseSolutions?.map((solution, index) => (
                                        <SolutionPreview
                                            solution={solution}
                                            isListLayout={false}
                                            key={index}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        )
    );
};
